import { useState } from "react";
import { Switch } from "../../../components/ReadonlyAwareInputs";
import CopyFromProdModal from "./CopyFromProd";
import NewGroupModal from "./NewGroup";

const CopyGroupModal = ({
  groupList,
  fetchGroups,
  resetForm,
  setResetForm,
  isClientFacing,
}) => {
  const [copyFromProd, setCopyFromProd] = useState(false);

  const updateCopyFromProdState = () => {
    setCopyFromProd((prevVal) => !prevVal);
  };

  return (
    <div>
      {!isClientFacing && (
        <div className="flex-left margin-bottom">
          <h1>Copy From Prod</h1>
          <Switch
            content="TEST"
            checked={copyFromProd}
            defaultChecked={copyFromProd}
            onChange={updateCopyFromProdState}
          />
        </div>
      )}
      {copyFromProd ? (
        <CopyFromProdModal />
      ) : (
        <NewGroupModal
          groupList={groupList}
          fetchGroups={fetchGroups}
          resetForm={resetForm}
          setResetForm={setResetForm}
        ></NewGroupModal>
      )}
    </div>
  );
};

export default CopyGroupModal;
